export const diseaseList = (state = [], action) => {
    switch (action.type) {
        case "diseaseList_add": return action.payload; 
        // case "diseaseList_remove": return "";
        case "diseaseList_reset": return [];
        default: return state;
    }
}
